export const getRpc = () => {
    return process.env.REACT_APP_NODE_1
}